// Chakra imports
import { Box, SimpleGrid } from '@chakra-ui/react';
import ListLoader from 'components/list/ListLoader';
import { useSite } from 'hooks/useSite';
import ColumnsTable from 'views/admin/sites/components/ColumnsTable';

export default function Sites() {
  const { getSites } = useSite();

  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <SimpleGrid mb='20px' columns={1} spacing={{ base: '20px', xl: '20px' }}>
        <ListLoader load={getSites}>{(data) => <ColumnsTable tableData={data} />}</ListLoader>
      </SimpleGrid>
    </Box>
  );
}
